// extracted by mini-css-extract-plugin
export default {"component-container":"ModuleSequencingSection_component-container__-CWrK","coming-soon":"ModuleSequencingSection_coming-soon__XqX6T"};